const clientPaymentMethodsEndpoint = "/AuthorizeDotNet/PaymentMethods";

export const validateCardCode = (input) => RegExp(/^\d{3}\d?$/).test(input);
export const validateCardNumber = (input) => 
  RegExp(/^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/).test(input);
export const validateExpDate = (input) => RegExp(/^((?:0[1-9])|(?:1[0-2]))\/\d\d$/).test(input);

export function GetPaymentMethods() {
  return fetch(
    clientPaymentMethodsEndpoint,
    {
        method: 'GET',
        headers: { "Content-Type": "application/json" },
        credentials: 'same-origin'
    });
}

export function GetPaymentMethod(paymentProfileId) {
  return fetch(
    `${clientPaymentMethodsEndpoint}/${paymentProfileId}`,
    {
        method: 'GET',
        headers: { "Content-Type": "application/json" },
        credentials: 'same-origin'
    });
}

export function CreatePaymentMethod(paymentProfile) {
  return fetch(
    clientPaymentMethodsEndpoint,
    {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        credentials: 'same-origin',
        body: JSON.stringify(paymentProfile)
    });
}

export function UpdatePaymentMethod(paymentProfile) {
  const paymentProfileId = paymentProfile.CustomerPaymentProfileId;

  return fetch(
    `${clientPaymentMethodsEndpoint}/${paymentProfileId}`,
    {
        method: 'PUT',
        headers: { "Content-Type": "application/json" },
        credentials: 'same-origin',
        body: JSON.stringify(paymentProfile)
    });
}

export function DeletePaymentMethod(paymentProfileId) {
  return fetch(
    `${clientPaymentMethodsEndpoint}/${paymentProfileId}`,
    {
        method: 'DELETE',
        headers: { "Content-Type": "application/json" },
        credentials: 'same-origin'
    });
}